<template>
  <div class="site-wrapper">
    <!-- 顶部 LOGO + 横向菜单 -->
    <header class="site-header">
      <div class="header-content">
        <div class="header-title">深圳量德信息技术有限公司</div>

        <!-- 手机端汉堡按钮 -->
        <button class="mobile-menu-btn" @click="drawerVisible = true" v-if="isMobile">
          ☰
        </button>

        <!-- PC端横向菜单 -->
        <el-menu
          v-if="!isMobile"
          mode="horizontal"
          :default-active="$route.path"
          router
          class="menu-bar"
        >
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/intro">公司简介</el-menu-item>
          <el-menu-item index="/products">产品与服务</el-menu-item>
          <el-menu-item index="/news">新闻动态</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </div>
    </header>

    <!-- 手机端抽屉菜单 -->
    <el-drawer
      v-model="drawerVisible"
      direction="ltr"
      size="70%"
      :with-header="false"
      class="mobile-drawer"
    >
      <el-menu
        mode="vertical"
        :default-active="$route.path"
        router
        @select="drawerVisible = false"   
      >
        <el-menu-item index="/home">首页</el-menu-item>
        <el-menu-item index="/intro">公司简介</el-menu-item>
        <el-menu-item index="/products">产品与服务</el-menu-item>
        <el-menu-item index="/news">新闻动态</el-menu-item>
        <el-menu-item index="/contact">联系我们</el-menu-item>
      </el-menu>
    </el-drawer>

    <main class="content-area">
      <router-view />
    </main>

    <footer class="site-footer">
      <div class="footer-container">
        ©2025 深圳量德信息技术有限公司 ｜ 
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025429382号</a>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const drawerVisible = ref(false)
const isMobile = ref(false)

function checkIsMobile() {
  const ua = navigator.userAgent || navigator.vendor || window.opera
  const isPhone = /android|iphone|ipad|ipod|windows phone|mobile/i.test(ua)
  isMobile.value = isPhone || window.innerWidth <= 768
}

onMounted(() => {
  checkIsMobile()
  window.addEventListener('resize', checkIsMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkIsMobile)
})
</script>

<style scoped>
.site-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content-area {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  flex: 1;
}

.site-header {
  background-color: #0a74da;
  color: white;
  padding: 0 20px;
}

.header-content {
  display: flex;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  height: 56px;
}

.header-title {
  font-size: 20px;
  font-weight: bold;
  color: white;
  white-space: nowrap;
  flex-shrink: 0;
  margin-right: 40px;
  user-select: none;
}

.menu-bar {
  flex-grow: 1;
  background-color: transparent;
  color: white;
  border-bottom: none;
  justify-content: flex-start !important;
}

/* 手机端汉堡菜单按钮 */
.mobile-menu-btn {
  font-size: 28px;
  background: #0a74da;  /* 科技蓝背景 */
  border: none;
  color: white;         /* 白色文字更显眼 */
  cursor: pointer;
  border-radius: 4px;
  padding: 4px 10px;
}

/* 只针对 PC 横向菜单的菜单项 */
.menu-bar :deep(.el-menu-item) {
  color: white !important;
  opacity: 1 !important;
  margin: 0 20px;
}

/* PC 横向菜单激活项样式 */
.menu-bar :deep(.el-menu-item.is-active) {
  background-color: #409EFF !important;
  color: white !important;
}
.menu-bar :deep(.el-menu-item.is-active):not(:hover) {
  color: white !important;
  opacity: 1 !important;
}
.menu-bar :deep(.el-menu-item.is-active:hover) {
  background-color: #66a1ff !important;
  color: white !important;
}
.menu-bar :deep(.el-menu-item:hover) {
  background-color: #2d66c2 !important;
  color: white !important;
}

/* 手机端抽屉菜单背景 */
.mobile-drawer {
  background-color: #0a74da;  /* 科技蓝背景 */
  padding: 20px 0;            /* 给点上下内边距 */
}

/* 手机端抽屉菜单项文字 */
.mobile-drawer :deep(.el-menu-item) {
  color: white !important;
  opacity: 1 !important;
  margin: 10px 20px;
  font-size: 18px;
}

/* 手机端抽屉激活菜单项 */
.mobile-drawer :deep(.el-menu-item.is-active) {
  background-color: #409EFF !important;
  color: white !important;
}

/* 手机端抽屉菜单悬停 */
.mobile-drawer :deep(.el-menu-item:hover) {
  background-color: #66a1ff !important;
  color: white !important;
}

.site-footer {
  background-color: #eeeeee;
  text-align: center;
  font-size: 14px;
  color: #666;
  padding: 16px 0;
  border-top: 1px solid #ddd;
  margin-top: auto;
}
.footer-container {
  max-width: 1200px;
  margin: 0 auto;
}
.site-footer a {
  color: #005bac;
  text-decoration: none;
}
</style>
